"use client";

import { c as _c } from "react/compiler-runtime";
import { sanitizeLessonHtml, type CampaignPageSection } from "@growwithai/shared";
import { RICH_HTML_CLASS } from "../types";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type FaqProps = Extract<CampaignPageSection, {
  type: "faq";
}>;

/** Accordion <details> — pola mengikuti halaman /faq eksisting; a_html disanitasi ulang. */
export default function FaqSection(t0) {
  const $ = _c(17);
  const {
    section
  } = t0;
  if (section.items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style) {
    t2 = sectionHeadingStyle(section.custom_style);
    $[2] = section.custom_style;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = section.heading ?? "Pertanyaan yang Sering Ditanya";
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <h2 className="text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={t2}>{t3}</h2>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== section.items) {
    t5 = section.items.map(_temp);
    $[7] = section.items;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div className="mt-8 space-y-2.5">{t5}</div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="mx-auto max-w-3xl px-5">{t4}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t7) {
    t8 = <section className="bg-warm-cream py-14 md:py-20" style={t1}>{t7}</section>;
    $[14] = t1;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(item, i) {
  return <details key={i} className="group rounded-xl border [border-color:var(--card-border-color,rgba(0,0,0,.08))] bg-white shadow-[var(--card-shadow,none)] [backdrop-filter:var(--card-backdrop,none)]"><summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-sm font-semibold text-warm-black hover:bg-warm-cream"><span className="min-w-0">{item.q}</span><span className="shrink-0 text-xl leading-none text-[var(--brand-primary)] transition-transform group-open:rotate-45">+</span></summary><div className={`px-5 pb-5 ${RICH_HTML_CLASS}`} dangerouslySetInnerHTML={{
      __html: sanitizeLessonHtml(item.a_html)
    }} /></details>;
}